export const loadInputPage = () => import('../components/TransactionInput');
export const loadOverviewPage = () => import('../components/TransactionSummary');

// Start loading on navigation intent, without speculative database reads.
export const preloadPrimaryPage = path => {
  const connection = navigator.connection;
  if (connection?.saveData || /(^|-)2g$/.test(connection?.effectiveType || '')) return;
  const load = path === '/input' ? loadInputPage : path === '/app' ? loadOverviewPage : null;
  if (load) load().catch(() => {}); // Actual navigation keeps the normal error handling.
};
